import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { type ConversationListStore } from 'pages/conversations/ui/ConversationList'
import { ConversationListContext } from 'pages/conversations/ui/ConversationList/context/conversationListContext'
import { ConversationListContent } from 'pages/conversations/ui/ConversationList/ui/ConversationListContent'

type IConversationListProps = {
  store: ConversationListStore
}

export const ConversationList: FC<IConversationListProps> = observer(({ store }) => {
  return (
    <ConversationListContext.Provider value={store}>
      <ConversationListContent virtualized />
    </ConversationListContext.Provider>
  )
})
